<div class="dashboard-main container-fluid" *ngIf="loader" style="height: 550px;">
    <div class="loaderwrapper" style="z-index: 1024;">
        <span class="loader"></span>
    </div>
</div>
<section class="dashboard-main container-fluid" *ngIf="permissionsReady && permissions.canView && !loader">
    <div class="contents-main">
        <div class="card table-card mb-3">
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Inverter Comparison</h1>
            </div>
        </div>
        <div class="bg-white rounded">
            <div class="row pb-5">
                <!-- Plant 1 Section -->
                <div class="col-md-6">
                    <div class="filters-holder main justify-content-center rounded">
                        <div class="form-group filter-wrap">
                            <ng-select [items]="filteredPlantList1" bindLabel="stationName" placeholder="Plant 1"
                                class="sb-filter-field" [(ngModel)]="selectedPlant1" (change)="selectPlant1($event)">
                            </ng-select>
                        </div>
                        <div class="form-group filter-wrap">
                            <ng-select [items]="deviceList1" bindLabel="devName" placeholder="Inverter 1"
                                class="sb-filter-field" class="limit-ng-value" [(ngModel)]="selectedInverter1"
                                (change)="selectInverter1($event)" [disabled]="!selectedPlant1">
                            </ng-select>
                        </div>
                    </div>
                </div>

                <!-- Plant 2 Section -->
                <div class="col-md-6">
                    <div class="filters-holder main justify-content-center rounded">
                        <div class="form-group filter-wrap">
                            <ng-select [items]="filteredPlantList2" bindLabel="stationName" placeholder="Plant 2"
                                [(ngModel)]="selectedPlant2" (change)="selectPlant2($event)">
                            </ng-select>
                        </div>
                        <div class="form-group filter-wrap">
                            <ng-select [items]="deviceList2" bindLabel="devName" placeholder="Inverter 2"
                                class="limit-ng-value" [(ngModel)]="selectedInverter2"
                                (change)="selectInverter2($event)" [disabled]="!selectedPlant2">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-md-6">
                    <div class="filters-holder main justify-content-center">
                        <div class="form-group filter-wrap">
                            <ng-select [items]="allPlantList" bindLabel="stationName" placeholder="Plant 1"
                                [(ngModel)]="selectedPlant1" (change)="selectPlant1($event)">
                            </ng-select>
                        </div>
                        <div class="form-group filter-wrap">
                            <ng-select [items]="deviceList1" bindLabel="devName" placeholder="Inverter 1"
                                class="limit-ng-value" [(ngModel)]="selectedInverter1"
                                (change)="selectInverter1($event)" [disabled]="!selectedPlant1">
                            </ng-select>
                        </div>
                    </div>
                </div> -->

                <!-- Plant 2 Section -->
                <!-- <div class="col-md-6">
                    <div class="filters-holder main justify-content-center">
                        <div class="form-group filter-wrap">
                            <ng-select [items]="allPlantList" bindLabel="stationName" placeholder="Plant 2"
                                [(ngModel)]="selectedPlant2" (change)="selectPlant2($event)">
                            </ng-select>
                        </div>
                        <div class="form-group filter-wrap">
                            <ng-select [items]="deviceList2" bindLabel="devName" placeholder="Inverter 2"
                                class="limit-ng-value" [(ngModel)]="selectedInverter2"
                                (change)="selectInverter2($event)" [disabled]="!selectedPlant2">
                            </ng-select>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="row px-5">
                <div class="col-md-12">
                    <div class="filters-holder sm justify-content-end mb-3">
                        <div class="form-group">
                            <ng-select [items]="pvTemperature" bindLabel="" placeholder="Temperature" bindValue=""
                                [multiple]="true" [closeOnSelect]="false" class="limit-ng-value"
                                [(ngModel)]="selectedTemperature" (change)="onDropdownSelectionChange()">
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value">
                                        <span class="ng-value-label">{{ items.length }} selected</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <ng-select [items]="pvCurrents" bindLabel="" placeholder="Current" bindValue=""
                                [multiple]="true" [closeOnSelect]="false" class="limit-ng-value"
                                [(ngModel)]="selectedCurrents" (change)="onDropdownSelectionChange()">
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value">
                                        <span class="ng-value-label">{{ items.length }} selected</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <ng-select [items]="pvFrequency" bindLabel="" placeholder="Frequency" bindValue=""
                                [multiple]="true" [closeOnSelect]="false" class="limit-ng-value" [items]="pvFrequency"
                                [(ngModel)]="selectedFrequency" (change)="onDropdownSelectionChange()">
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value">
                                        <span class="ng-value-label">{{ items.length }} selected</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <ng-select [items]="pvEnergy" bindLabel="" placeholder="Energy" bindValue=""
                                [multiple]="true" [closeOnSelect]="false" class="limit-ng-value"
                                [(ngModel)]="selectedEnergy" (change)="onDropdownSelectionChange()">
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value">
                                        <span class="ng-value-label">{{ items.length }} selected</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <ng-select [items]="pvPowers" bindLabel="" placeholder="Power" bindValue=""
                                [multiple]="true" [closeOnSelect]="false" class="limit-ng-value"
                                [(ngModel)]="selectedPowers" (change)="onDropdownSelectionChange()">
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value">
                                        <span class="ng-value-label">{{ items.length }} selected</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <ng-select [items]="pvVoltages" bindLabel="" placeholder="Voltage" bindValue=""
                                [multiple]="true" [closeOnSelect]="false" class="limit-ng-value"
                                [(ngModel)]="selectedVoltages" (change)="onDropdownSelectionChange()">
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value">
                                        <span class="ng-value-label">{{ items.length }} selected</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <ng-select [items]="pvPercentage" bindLabel="" placeholder="Percentage" bindValue=""
                                [multiple]="true" [closeOnSelect]="false" class="limit-ng-value"
                                [(ngModel)]="selectedPercentage" (change)="onDropdownSelectionChange()">
                                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                    <div class="ng-value">
                                        <span class="ng-value-label">{{ items.length }} selected</span>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="form-group input-group daterange-wrapper">
                            <input type="text" class="form-control readonly-g-white" bsDatepicker
                                [bsConfig]="datePickerConfig" #dp="bsDatepicker" placeholder="Date Range"
                                [ngModel]="selectedPVDate" readonly (ngModelChange)="onDateChange($event)" />

                            <div class="input-group-append" (click)="dp.toggle()">
                                <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                                        fill="none">
                                        <path
                                            d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                            fill="currentColor" />
                                    </svg></span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="pv-chart-container">
                        <div class="loaderwrapper" *ngIf="this.loader" style="z-index: 1024;">
                            <span class="loader"></span>
                        </div>
                        <div class="chart-wrapper">

                            <div *ngIf="pvMultilineChartOptions && !loader && hasFiltersSelected()"
                                style="width: 100%;">
                                <highcharts-chart #pvMultiChart [Highcharts]="Highcharts"
                                    [options]="pvMultilineChartOptions" [update]="updateFlag" [oneToOne]="true">
                                </highcharts-chart>
                            </div>

                            <div *ngIf="!hasFiltersSelected() && !loader" class="text-muted text-center py-5">
                                Please select at least one filter to display the chart.
                            </div>
                        </div>
                    </div> -->
                    <div class="pv-chart-container">
                        <div class="loaderwrapper" *ngIf="this.loader" style="z-index: 1024;">
                            <span class="loader"></span>
                        </div>
                        <div class="chart-wrapper">
                            <!-- Show chart if chart options exist and data is loaded -->
                            <!-- <div *ngIf="pvMultilineChartOptions && !loader && hasFiltersSelected()"
                                style="width: 100%;">
                                <highcharts-chart #pvMultiChart [Highcharts]="Highcharts"
                                    [options]="pvMultilineChartOptions" [update]="updateFlag" [oneToOne]="true">
                                </highcharts-chart>
                            </div> -->
                            <div *ngIf="
      pvMultilineChartOptions &&
      pvMultilineChartOptions.series &&
      pvMultilineChartOptions.series.length > 0 &&
      !loader &&
      hasFiltersSelected()
    " style="width: 100%;">

                                <highcharts-chart #pvMultiChart [Highcharts]="Highcharts"
                                    [options]="pvMultilineChartOptions" [update]="updateFlag" [oneToOne]="true">
                                </highcharts-chart>
                            </div>

                            <!-- Show progressive messages based on selection state -->
                            <!-- <div *ngIf="!loader && !pvMultilineChartOptions" class="empty-state text-center py-5"> -->
                            <div *ngIf="!loader && (!pvMultilineChartOptions || (pvMultilineChartOptions.series?.length ?? 0) === 0)"
                                class="empty-state text-center py-5">

                                <!-- No plants selected -->
                                <div *ngIf="!selectedPlant1 && !selectedPlant2" class="text-muted">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" style="opacity: 0.3; margin-bottom: 16px;">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                    </svg>
                                    <h5 class="mb-2">No Plants Selected</h5>
                                    <p class="mb-0">Please select at least one plant and its inverter to begin
                                        comparison.</p>
                                </div>

                                <!-- Plants selected but no inverters -->
                                <div *ngIf="(selectedPlant1 && !selectedInverter1) || (selectedPlant2 && !selectedInverter2)"
                                    class="text-muted">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" style="opacity: 0.3; margin-bottom: 16px;">
                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="9" y1="9" x2="15" y2="15"></line>
                                        <line x1="15" y1="9" x2="9" y2="15"></line>
                                    </svg>
                                    <h5 class="mb-2">Select Inverters</h5>
                                    <p class="mb-0">Please select inverters for the chosen plant(s) to load data.</p>
                                </div>

                                <!-- Inverters selected but no filters -->
                                <div *ngIf="(selectedInverter1 || selectedInverter2) && !hasFiltersSelected() && (plant1Data || plant2Data)"
                                    class="text-muted">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" style="opacity: 0.3; margin-bottom: 16px;">
                                        <line x1="4" y1="21" x2="4" y2="14"></line>
                                        <line x1="4" y1="10" x2="4" y2="3"></line>
                                        <line x1="12" y1="21" x2="12" y2="12"></line>
                                        <line x1="12" y1="8" x2="12" y2="3"></line>
                                        <line x1="20" y1="21" x2="20" y2="16"></line>
                                        <line x1="20" y1="12" x2="20" y2="3"></line>
                                        <line x1="1" y1="14" x2="7" y2="14"></line>
                                        <line x1="9" y1="8" x2="15" y2="8"></line>
                                        <line x1="17" y1="16" x2="23" y2="16"></line>
                                    </svg>
                                    <h5 class="mb-2">Select Filters</h5>
                                    <p class="mb-0">Choose at least one filter (Voltage, Current, Power, etc.) to
                                        display the comparison chart.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- NO VIEW PERMISSION (FULL PAGE) -->
<section *ngIf="permissionsReady && !permissions.canView && !loader" class="dashboard-main container-fluid bg-white">
    <div class="contents-main">
        <div class="row">
            <div class="col-12">
                <div class="empty-state text-center d-flex flex-column align-items-center justify-content-center py-5">
                    <i class="fa fa-lock fa-3x mb-3 text-muted"></i>
                    <h5 class="mb-2">Access Restricted</h5>
                    <p class="text-muted">
                        You don’t have permission to view this report.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>